import { render, staticRenderFns } from "./accounts.page.vue?vue&type=template&id=29012039&"
import script from "./accounts.page.vue?vue&type=script&lang=ts&"
export * from "./accounts.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports